import { COUNTRY_OPTIONS } from "./constants";

export const addCountryCode = (phoneNumber, countryCode) => {
  if (phoneNumber === null || phoneNumber === "" || phoneNumber === undefined) return null;

  const selected = COUNTRY_OPTIONS.find((option) => option.code === countryCode);
  const rawPhoneNumber = phoneNumber;
  const strippedNumber = rawPhoneNumber?.replace(/\D+/g, "").trim();
  const e64Formatted = `${selected.value}${strippedNumber}`;

  if (rawPhoneNumber.startsWith("+")) return rawPhoneNumber;

  return e64Formatted;
};

export const removeCountryCode = (phoneNumber) => {
  if (!phoneNumber) return;

  if (phoneNumber.startsWith("+1")) return phoneNumber.slice(2);
  if (phoneNumber.startsWith("+44") || phoneNumber.startsWith("+61")) {
    return phoneNumber.slice(3);
  }
};
